import { UserProfileResult } from '@mews-commander/data-access';
import { Avatar, Body, Link, Stack, Typography } from '@optimus-web/core';
import { useGetAvatarSrc } from '@mews-commander/utils';
import { useUserDetailContext } from '../context/userDetailContext';

interface UserTableAvatarProps {
    userProfile: UserProfileResult;
    preventClick?: boolean;
}

export const UserTableAvatar = ({ userProfile, preventClick }: UserTableAvatarProps) => {
    const { openUserDetail } = useUserDetailContext();

    const getAvatarSrc = useGetAvatarSrc();
    const avatarImage = getAvatarSrc(userProfile.imageId);

    return (
        <Stack spacing="100" itemAlignment="center">
            <Avatar src={avatarImage} title={userProfile.fullName || ''} size="small" />
            <Body size="small" ellipsis maxLines={1}>
                {preventClick ? (
                    <span>{userProfile.fullName}</span>
                ) : (
                    <Link variant="basic" onClick={() => openUserDetail({ userId: userProfile.userId })}>
                        {userProfile.fullName}
                    </Link>
                )}
                <Typography ellipsis maxLines={1} textStyle="bodyMedium" variant="tertiary" as="div">
                    {userProfile.email}
                </Typography>
            </Body>
        </Stack>
    );
};
